import { PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { DocumentoArquivoDTO } from '../ptc/documento-arquivo.dto';

export class ConcessaoColetivoUrbanoDTO extends Concessao{

    concessionario: PessoaJuridica = void(0);
    qtdVeiculosManutencao: number = void(0);
    qtdVeiculosVinculados: number = void(0);
    qtdLinhas: number = void(0);
    documentoArquivoDTO: Array<DocumentoArquivoDTO> = void(0);

    constructor(
        concessionario?: PessoaJuridica,
        qtdVeiculosVinculados?: number,
        qtdVeiculosManutencao?: number,
        qtdLinhas?: number,
        documentoArquivoDTO?: Array<DocumentoArquivoDTO>
    ) {
        super();
        this.qtdVeiculosVinculados = qtdVeiculosVinculados;
        this.qtdVeiculosManutencao = qtdVeiculosManutencao;
        this.concessionario = concessionario;
        this.qtdLinhas = qtdLinhas;
        this.documentoArquivoDTO = documentoArquivoDTO;
    }
}

export class ConcessaoColetivoUrbanoDTOList {
    items: Array<ConcessaoColetivoUrbanoDTO>;
    total: number;

    constructor() {}
}